import { render } from "./InputFormComponent.vue?vue&type=template&id=557c227c&scoped=true"
import script from "./InputFormComponent.vue?vue&type=script&lang=js"
export * from "./InputFormComponent.vue?vue&type=script&lang=js"

import "./InputFormComponent.vue?vue&type=style&index=0&id=557c227c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557c227c"]])

export default __exports__